  function getSymbol(currencyCode) {
    const currencySymbols = {
      AED: 'د.إ',
      AFN: '؋',
      ALL: 'L',
      AMD: '֏',
      ANG: 'ƒ',
      AOA: 'Kz',
      ARS: '$',
      AUD: 'A$',
      AWG: 'ƒ',
      AZN: '₼',
      BAM: 'KM',
      BBD: '$',
      BDT: '৳',
      BGN: 'лв',
      BHD: '.د.ب',
      BIF: 'FBu',
      BMD: '$',
      BND: '$',
      BOB: 'Bs.',
      BRL: 'R$',
      BSD: '$',
      BTN: 'Nu.',
      BWP: 'P',
      BYN: 'Br',
      BZD: '$',
      CAD: 'C$',
      CDF: 'FC',
      CHF: 'CHF',
      CLP: '$',
      CNY: '¥',
      COP: '$',
      CRC: '₡',
      CUP: '$',
      CVE: '$',
      CZK: 'Kč',
      DJF: 'Fdj',
      DKK: 'kr',
      DOP: '$',
      DZD: 'د.ج',
      EGP: '£',
      ERN: 'Nfk',
      ETB: 'Br',
      EUR: '€',
      FJD: '$',
      FKP: '£',
      FOK: 'kr',
      GBP: '£',
      GEL: '₾',
      GGP: '£',
      GHS: '₵',
      GIP: '£',
      GMD: 'D',
      GNF: 'FG',
      GTQ: 'Q',
      GYD: '$',
      HKD: 'HK$',
      HNL: 'L',
      HRK: 'kn',
      HTG: 'G',
      HUF: 'Ft',
      IDR: 'Rp',
      ILS: '₪',
      IMP: '£',
      INR: '₹',
      IQD: 'ع.د',
      IRR: '﷼',
      ISK: 'kr',
      JMD: '$',
      JOD: 'د.ا',
      JPY: '¥',
      KES: 'KSh',
      KGS: 'лв',
      KHR: '៛',
      KID: '$',
      KMF: 'CF',
      KRW: '₩',
      KWD: 'د.ك',
      KYD: '$',
      KZT: '₸',
      LAK: '₭',
      LBP: 'ل.ل',
      LKR: 'Rs',
      LRD: '$',
      LSL: 'L',
      LYD: 'ل.د',
      MAD: 'د.م.',
      MDL: 'L',
      MGA: 'Ar',
      MKD: 'ден',
      MMK: 'K',
      MNT: '₮',
      MOP: 'MOP$',
      MRU: 'UM',
      MUR: '₨',
      MVR: 'Rf',
      MWK: 'MK',
      MXN: '$',
      MYR: 'RM',
      MZN: 'MT',
      NAD: '$',
      NGN: '₦',
      NIO: 'C$',
      NOK: 'kr',
      NPR: '₨',
      NZD: 'NZ$',
      OMR: 'ر.ع.',
      PAB: 'B/.',
      PEN: 'S/',
      PGK: 'K',
      PHP: '₱',
      PKR: '₨',
      PLN: 'zł',
      PYG: '₲',
      QAR: 'ر.ق',
      RON: 'lei',
      RSD: 'дин.',
      RUB: '₽',
      RWF: 'FRw',
      SAR: '﷼',
      SBD: '$',
      SCR: '₨',
      SDG: 'ج.س.',
      SEK: 'kr',
      SGD: '$',
      SHP: '£',
      SLL: 'Le',
      SOS: 'Sh',
      SRD: '$',
      SSP: '£',
      STN: 'Db',
      SYP: '£',
      SZL: 'E',
      THB: '฿',
      TJS: 'ЅМ',
      TMT: 'm',
      TND: 'د.ت',
      TOP: 'T$',
      TRY: '₺',
      TTD: '$',
      TVD: '$',
      TWD: 'NT$',
      TZS: 'Sh',
      UAH: '₴',
      UGX: 'USh',
      USD: '$',
      UYU: '$',
      UZS: 'soʻm',
      VES: 'Bs.',
      VND: '₫',
      VUV: 'VT',
      WST: 'T',
      XAF: 'FCFA',
      XCD: '$',
      XOF: 'CFA',
      XPF: '₣',
      YER: '﷼',
      ZAR: 'R',
      ZMW: 'K',
      ZWL: '$',
    };
  
    return currencySymbols[currencyCode] || currencyCode;
  }

  function isString(value) {
    return typeof value === 'string' || value instanceof String;
  }

  const CUSTOM_FORMATS = {
    'financial': {
        minDecimals: 2,
        maxDecimals: 2,
        compact: false,
        showSymbol: true
    },
    'compact': {
        minDecimals: 1,
        maxDecimals: 1,
        compact: true,
        showSymbol: true
    },
    'minimal': {
        minDecimals: 0,
        maxDecimals: 0,
        compact: true,
        showSymbol: false
    }
  };

  const formatCurrency = (amount, currency = 'USD') => {
    const format = CUSTOM_FORMATS['financial'] || CUSTOM_FORMATS.financial;
    return formatInternalCurrency({
        amount,
        currency,
        ...format
    });
  };

  function formatWithStyle(amount, style = 'financial', currency = 'USD') {
    const format = CUSTOM_FORMATS[style] || CUSTOM_FORMATS.financial;
    return formatInternalCurrency({
        amount,
        currency,
        ...format
    });
  };

  function formatInternalCurrency({
    amount,
    currency = this.defaultCurrency,
    compact = false,
    minDecimals = 2,
    maxDecimals = 2,
    locale = undefined
  }) {
    try {
        // Convert to number and handle invalid input
        const numAmount = Number(amount);
        if (isNaN(numAmount)) {
            return `${getSymbol(currency)}0.00`;
        }

        // Get absolute value and check if negative
        const isNegative = numAmount < 0;
        const absAmount = Math.abs(numAmount);

        let formatted;

        if (compact && absAmount >= 1000) {
            // Compact notation for large numbers
            if (absAmount >= 1_000_000_000) {
                formatted = `${(absAmount / 1_000_000_000).toFixed(1)}B`;
            } else if (absAmount >= 1_000_000) {
                formatted = `${(absAmount / 1_000_000).toFixed(1)}M`;
            } else if (absAmount >= 1_000) {
                formatted = `${(absAmount / 1_000).toFixed(1)}K`;
            }
        } else {
            // Standard notation with locale formatting
            formatted = absAmount.toLocaleString(locale, {
                minimumFractionDigits: minDecimals,
                maximumFractionDigits: maxDecimals,
                useGrouping: true
            });
        }

        // Combine symbol and formatted number
        const symbol = getSymbol(currency);
        const result = `${symbol}${formatted}`;

        // Add negative sign if needed
        return isNegative ? `-${result}` : result;

    } catch (error) {
        console.error('Error formatting currency:', error);
        return `${getSymbol(currency)}0.00`;
    }
  };

  const formatNumber = (amount) => {
    return `${Number(amount).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const formatInterest = (amount) => {
    return parseFloat(parseFloat(amount) * 100.0).toFixed(2) + '%';
  };

  const formatInterestFra = (amount) => {
    return parseFloat(parseFloat(amount)).toFixed(2) + '%';
  };

  const formatDateIntl = (isoString) => {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(new Date(isoString));
  }

  const formatPercentage = (amount) => {
    return parseFloat(parseFloat(amount) * 100.0).toFixed(2) + '%';
  };

  export {getSymbol, formatWithStyle, formatNumber, formatInterestFra, formatCurrency, formatInterest, formatDateIntl, formatPercentage};
  